import React from "react";
import { Navigate } from "react-router";
import Base from "../Base";
import SelectAsync from 'react-select/async';

export default class Andikator extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            data: null,
            loading: true,
            //   innerStatus: 0,
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        var p1 = this.httpPost("api/v1/andikator/get", {
            id: this.getCurrentFormId(),
        }).then((data) => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.state.data = data;
            }
        });
        Promise.all([p1]).then((r) => {
            this.setState({
                loading: false,
            });
        });
    }

    save(e) {
        if (!this.isNull(e)) e.preventDefault();

        this.httpPost("api/v1/andikator/save", {
            id: this.state.id,
            title: this.state.data.record.title,
            startNumber: this.state.data.record.startNumber,
            postfix: this.state.data.record.postfix,
            prefix: this.state.data.record.prefix,
            type: this.state.data.record.type,
            status: this.state.data.record.status,
            isDefault: this.state.data.record.isDefault,
        }).then((data) => {
            if (data.status === -1) window.location.href = "/login";
            this.state.innerStatus = data.innerStatus;
            if (data.status === 1) {
                this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                this.state.caller.refreshData();
                this.closeMe();
            } else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false,
                });
            }
        });
    }
    renderForm() {
        return (
            <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
                <div
                    className="modal-backdrop fade in"
                    style={{ height: "100%" }}
                    onClick={(e) => this.closeMe()}
                ></div>
                <div className="modal-dialog ui-draggable">
                    <div className="modal-content">
                        <div className="modal-body" style={{ padding: "0" }}>
                            <div className="modal-header modal-header-info">
                                <button
                                    type="button"
                                    className="close"
                                    onClick={(e) => this.closeMe()}
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">×</span>
                                </button>
                                <h4 className="modal-title">
                                    {this.state.data.record.id != this.defaultGuid()
                                        ? "ویرایش اطلاعات اندیکاتور"
                                        : "افزودن اندیکاتور"}
                                </h4>
                            </div>
                            <div className="modal-body">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="form-group">
                                                <label for="name" className="title1">
                                                    عنوان :
                                                </label>
                                                <input
                                                    defaultValue={this.state.data.record.title}
                                                    autocomplete="off"
                                                    onChange={(e) =>
                                                    (this.state.data.record.title =
                                                        e.target.value
                                                    )
                                                    }
                                                    type="text"
                                                    className="form-control input-sm"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row mt-4">
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <label for="name" className="title1">
                                                    شروع شماره گذاری :
                                                </label>
                                                <input
                                                    defaultValue={this.state.data.record.startNumber}
                                                    autocomplete="off"
                                                    type="text"
                                                    className="form-control input-sm ltr"
                                                    onChange={(e) =>
                                                    this.state.data.record.startNumber =
                                                        parseInt(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <label for="name" className="title1">
                                                    پسوند شماره گذاری:
                                                </label>
                                                <input
                                                    defaultValue={this.state.data.record.postfix}
                                                    autocomplete="off"
                                                    type="text"
                                                    className="form-control input-sm ltr"
                                                    onChange={(e) =>
                                                    this.state.data.record.postfix =
                                                        e.target.value
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <label for="name" className="title1">
                                                    پیشوند شماره گذاری:
                                                </label>
                                                <input
                                                    defaultValue={this.state.data.record.prefix}
                                                    autocomplete="off"
                                                    type="text"
                                                    className="form-control input-sm ltr"
                                                    onChange={(e) =>
                                                    this.state.data.record.prefix =
                                                        e.target.value
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <label for="name" className="title1">
                                                    نوع نامه :
                                                </label>
                                                <select
                                                    defaultValue={this.state.data.record.type}
                                                    onChange={(e) => this.state.data.record.type = parseInt(e.target.value)}
                                                    className="form-control text-center">
                                                    <option value="0">انتخاب کنید .....</option>
                                                    <option value="1">نامه داخلی</option>
                                                    <option value="2">نامه صادره</option>
                                                    <option value="3">نامه وارده</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <label for="name" className="title1">
                                                    وضعیت :
                                                </label>
                                                <select
                                                    defaultValue={this.state.data.record.status}
                                                    onChange={(e) => this.state.data.record.status = parseInt(e.target.value)}
                                                    className="form-control text-center">
                                                    <option value="0">فعال</option>
                                                    <option value="1">غیرفعال</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-lg-3">
                                            <input
                                                defaultChecked={this.state.data.record.isDefault}
                                                type="checkbox"
                                                onChange={(e) => this.state.data.record.isDefault = e.target.checked}
                                            />
                                            اندیکاتور پیش فرض گروه
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-default btn-smoke" onClick={(e) => this.closeMe()}>
                                    انصراف
                                </button>
                                <button type="submit" name="bank_form_modal_submit" className="btn btn-success" onClick={e => this.save(e)}>
                                    ذخیره
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    render() {
        if (!this.isBlank(this.state.redirect))
            return <Navigate to={this.state.redirect} />;

        let contents = this.state.loading
            ? this.renderLoading()
            : [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
            ];

        return contents;
    }
}